/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  /**
   * Хелпер межсервисной связи
   */
  app.helpers.CQCHelper = {
    executeChannel: null,
    commandChannel: null,
    /**
     * Создает канал обработки команд
     * @param {Array} commandTypes - массив типов команд которые можно принять
     */
    createExecuteChannel: function (commandTypes) {
      if (typeof CQC !== 'undefined'
        && typeof CQC.execute === 'function'
        && commandTypes.length) {
        this.executeChannel = CQC.execute(commandTypes, app.ES5_CONTEXT);
      }
    },

    /**
     * Создает канал отсылки команд
     * @param {Array} commandTypes - массив типов команд которые можно отсылать
     */
    createCommandChannel: function (commandTypes) {
      if (typeof CQC !== 'undefined'
        && typeof CQC.command === 'function'
        && commandTypes.length) {
        this.commandChannel = CQC.command(commandTypes, app.ES5_CONTEXT);

        Backbone.on(app.CQC_COMMAND_EVENT, this._sendCommand.bind(this));
      }
    },

    /**
     * Подписка на команды
     * @param {string|Array} commandTypes - типы команды | массив типов команд
     * @param {Function} callback - функция-коллбэк
     */
    subscribeToCommand: function (commandTypes, callback) {
      callback = callback || this._defaultCqcCallback.bind(this);
      if (typeof this.executeChannel === 'function') {
        var executeFunction = function (promiseFunction) {
          if (typeof promiseFunction === 'function') {
            var promise = promiseFunction();
            promise.then(
              function (command) {
                callback(command);
              },
              function (error) {
                if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
                  Raven.captureException(error);
                } else {
                  throw error;
                }
              }
            );
          }
        };
        this.executeChannel(commandTypes)(executeFunction);
      }
    },

    /**
     * Дефолтный коллбэк при получении cqc команды
     * @param {Object} command - команда
     * @private
     */
    _defaultCqcCallback: function (command) {
      Backbone.trigger(app.CQC_COMMANDS_TYPES_TO_EVENTS[command.type], command);
    },

    /**
     * Отправка команды
     * @param {Object} command - команда
     * @private
     */
    _sendCommand: function (command) {
      if (typeof this.commandChannel === 'function' && command.type) {
        this.commandChannel(command);
      }
    },
  };
})();

}.call(window));